import { useNavigate } from 'react-router';
import { Button } from 'framework/button';
import { Input } from 'framework/Input';
import { PUBLIC } from 'router/routes';

import { EMPTY_FUNCTION } from '../../../../constants';
import { PasswordResetProps } from '../types';

import cn from '../PasswordRequestPage.module.scss';
const { PUBLIC_URL } = process.env;

export const PasswordReset = ({
  form,
  onChange = EMPTY_FUNCTION,
  onSubmit = EMPTY_FUNCTION,
}: PasswordResetProps) => {
  const navigate = useNavigate();

  return (
    <form className={cn.form} onSubmit={onSubmit}>
      <div className={cn.logo}>
        <img src={`${PUBLIC_URL}/voladeum/voladeum-vertical.png`} alt="Voladeum" />
      </div>
      <Input
        height="34px"
        onChange={({ value }) => onChange({ login: value })}
        value={form.login}
        placeholder="Email Address"
      />
      <Button type="submit" width="100%" height="36px" shadow>
        Reset password
      </Button>
      <div className={cn.row}>
        <div className={cn.break} />
        <p className={cn.text}>OR</p>
        <div className={cn.break} />
      </div>
      <Button
        width="100%"
        height="36px"
        variant="secondary"
        onClick={() => navigate(PUBLIC.CREATE_ACCOUNT.path)}
        shadow
      >
        Create account
      </Button>
    </form>
  );
};
